<template>
  <div class="pmenu" ref="pmenu">
    <div class="menubox">
      <a href="index.html">
        <img src="../../public/image/logo.png" alt />
      </a>
      <div class="navbox" @click="active = !active">
        <div class="nav" :class="{ nav1: active }"></div>
        <div class="nav" :class="{ nav2: active }"></div>
        <div class="nav" :class="{ nav3: active }"></div>
      </div>
    </div>
    <div class="menulist" :class="{ active_list: active }">
      <!-- <div class="back"></div> -->
      <ul>
        <li :class="{ a_active: active }" style="animation-delay:0.6s">
          <a href="index.html">{{ $t("list")[0] }}</a>
        </li>
        <li :class="{ a_active: active }" style="animation-delay:0.7s">
          <a href="about.html">{{ $t("list")[1] }}</a>
        </li>
        <li :class="{ a_active: active }" style="animation-delay:0.8s">
          <a href="produce.html">{{ $t("list")[2] }}</a>
        </li>
        <li :class="{ a_active: active }" style="animation-delay:0.9s">
          <a href="news.html">{{ $t("list")[3] }}</a>
        </li>
        <li :class="{ a_active: active }" style="animation-delay:1s">
          <a href="sale.html">{{ $t("list")[4] }}</a>
        </li>
        <li :class="{ a_active: active }" style="animation-delay:1.1s">
          <a href="contact.html">{{ $t("list")[5] }}</a>
        </li>
        <li :class="{ a_active: active }" style="animation-delay:1.2s">
          <div class="langs">
            <p @click="changeLan('zh-CN')">中文版</p>
            <p @click="changeLan('en')">ENGLISH</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { setup } from "@/local/index";
import { windowWidth, mobileWidth } from "@/util/util";
export default {
  data() {
    return {
      active: false,
    };
  },
  mounted() {
    const _this = this;
    _this.$nextTick(() => {
      if (windowWidth() <= mobileWidth) {
        _this.calcTopHeight();
      }
    });
  },
  methods: {
    changeLan(n) {
      this.$i18n.locale = n;
      window.localStorage.setItem("language", n);
      setup(n);
      window.location.reload();
    },
    calcTopHeight() {
      const topEleHeight = this.$refs.pmenu.clientHeight;
      this.$store.commit("setTopHeight", {
        h: topEleHeight,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pmenu {
  display: none;
  position: fixed;
  top: 0;
  height: 60px;
  width: 100%;
  // background-color: red;
}
.menubox {
  display: flex;
  height: 60px;
  align-items: center;
  background-color: white;
  a {
    margin-left: 20px;
    z-index: 10;
    img {
      height: 30px;
      object-fit: contain;
    }
  }
  .navbox {
    margin-left: auto;
    margin-right: 20px;
    z-index: 10;
    .nav {
      width: 30px;
      height: 2px;
      background-color: #333333;
      margin: 8px 0;
      transition: all 600ms;
    }
    .nav1 {
      transform: rotate(45deg) translateY(14px);
    }
    .nav2 {
      transform: translateX(30px);
      opacity: 0;
    }
    .nav3 {
      transform: rotate(-45deg) translateY(-14px);
    }
  }
}
.menulist {
  width: 100%;
  transform: translateY(-100%);
  transition: all 600ms;
  .back {
    width: 100%;
    height: 600px;
    filter: blur(20px);
  }
  .langs {
    display: flex;
    justify-content: center;
    p {
      margin: 0 20px;
    }
  }
  ul {
    z-index: 8;
    padding-top: 20px;
    background-color: white;
    li {
      padding-bottom: 30px;
      text-align: center;
      list-style: none;
      transform: translateX(-100%);
      a {
        font-family: "SOURCEHANSANSCN-NORMAL";
      }
    }
    .a_active {
      animation-name: identifier;
      animation-duration: 1s;
      animation-fill-mode: forwards;
    }

    @keyframes identifier {
      0% {
        transform: translateX(-250px);
      }
      100% {
        transform: translateX(0);
      }
    }
  }
}
.active_list {
  transform: translateY(0);
}
@media screen and (max-width: 1000px) {
  .pmenu {
    display: block;
  }
}
</style>
